import React from "react";
import "./App.css";
import lockupHorizontal from "./assets/brand/lockup-horizontal.svg";

const updated = new Date().toLocaleDateString("en-GB", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

export default function PrivacyPolicy({ onClose }) {
  return (
    <div className="legal-page">
      <nav className="landing-nav">
        <div className="landing-nav-brand">
          <img
            src={lockupHorizontal}
            alt="SuqPOS"
            style={{ height: "36px", width: "auto" }}
          />
        </div>
        <div className="landing-nav-actions">
          <button className="report-close" onClick={onClose}>
            ✕
          </button>
        </div>
      </nav>

      <article className="legal-content">
        <h1>Privacy Policy</h1>
        <p className="legal-updated">Last updated: {updated}</p>

        <h2>Who we are</h2>
        <p>
          SuqPOS is operated by Teccane Solutions ("we", "us"), an
          independent software provider based in Ethiopia. This policy
          explains what personal data we collect, why, and how we handle
          it.
        </p>
        <p>Contact: suqpos@zoho.com</p>

        <h2>What we collect</h2>
        <p>
          <strong>When you apply for early access (waitlist):</strong>
        </p>
        <ul>
          <li>
            Name, email address, phone number, store name, and any message
            you provide
          </li>
        </ul>

        <p>
          <strong>When you create a store account:</strong>
        </p>
        <ul>
          <li>
            Name, email, phone number, business address, and business tax
            identification number (TIN), if provided
          </li>
          <li>
            Login credentials, managed securely via our authentication
            provider
          </li>
        </ul>

        <p>
          <strong>When you use the app as a store owner or staff member:</strong>
        </p>
        <ul>
          <li>
            Sales, inventory, product, and customer transaction data you
            enter
          </li>
          <li>Staff account details (name, role) for accounts you create</li>
        </ul>

        <p>
          <strong>Automatically:</strong>
        </p>
        <ul>
          <li>
            We do not use analytics or tracking scripts. The app loads
            fonts from Google Fonts, which involves a request to Google's
            servers containing standard web request information (such as
            your IP address) — this is a functional requirement of
            displaying the app's typography, not tracking.
          </li>
        </ul>

        <h2>Why we collect it</h2>
        <ul>
          <li>
            To operate your store's point-of-sale system (sales, inventory,
            staff management)
          </li>
          <li>To evaluate and respond to early-access applications</li>
          <li>To provide customer support</li>
          <li>To notify you about your account or service changes</li>
        </ul>
        <p>
          We do not sell your data, and we do not use your data for
          advertising.
        </p>

        <h2>Who we share it with</h2>
        <p>
          We use the following third-party service providers to operate
          SuqPOS:
        </p>
        <ul>
          <li>
            <strong>Supabase</strong> — database, authentication, and
            backend hosting for all store data
          </li>
          <li>
            <strong>Vercel</strong> — application hosting
          </li>
          <li>
            <strong>Telegram</strong> — internal notifications to us when
            someone applies for early access (your application details are
            sent to our team's Telegram, not made public)
          </li>
          <li>
            <strong>Google Fonts</strong> — typography, as described above
          </li>
        </ul>
        <p>
          Each of these providers processes data on our behalf and is
          bound by its own privacy and security practices. We do not share
          your data with anyone else, except where required by law.
        </p>

        <h2>Data retention</h2>
        <p>
          We retain your data for as long as your store account is active.
          If you close your account, we will delete or anonymize your data
          within a reasonable period, except where we're required to
          retain it for legal or accounting reasons.
        </p>
        <p>
          Waitlist applications that are not approved may be retained to
          avoid duplicate submissions and to consider you for future
          access.
        </p>

        <h2>Your rights</h2>
        <p>
          You can request access to, correction of, or deletion of your
          personal data at any time by contacting suqpos@zoho.com. If
          you're a staff member of a store using SuqPOS, your store's
          manager is the primary controller of your account data — you can
          also request assistance through them.
        </p>

        <h2>Data security</h2>
        <p>
          We take reasonable technical and organizational measures to
          protect your data, including role-based access controls and
          encrypted data storage. No system is completely secure, and we
          cannot guarantee absolute security.
        </p>

        <h2>Changes to this policy</h2>
        <p>
          We may update this policy as SuqPOS grows. We'll update the
          "Last updated" date above when we do. Continued use of SuqPOS
          after changes means you accept the updated policy.
        </p>

        <h2>Contact</h2>
        <p>Questions about this policy or your data: suqpos@zoho.com</p>
      </article>

      <footer className="landing-footer">
        <div className="landing-footer-brand">
          <img
            src={lockupHorizontal}
            alt="SuqPOS"
            style={{ height: "24px", width: "auto", verticalAlign: "middle" }}
          />
        </div>
        <p style={{ fontSize: "12px", color: "var(--text3)", marginTop: "8px" }}>
          © {new Date().getFullYear()} SuqPOS · Smart Sales · Anywhere
        </p>
      </footer>
    </div>
  );
}
